import React from 'react';
import PropTypes from 'prop-types';

const SuggestionListItem = ({ onItemClick, value, isActive }) => {
    return (
        <li onClick={() => onItemClick(value)} className={isActive && 'active'}>
            {value}
        </li>
    );
};

SuggestionListItem.propTypes = {
    value: PropTypes.string.isRequired,
    onItemClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
};

SuggestionListItem.displayName = 'SuggestionListItem';

export default SuggestionListItem;
